import { render, staticRenderFns } from "./editVirtualColumnFilter.vue?vue&type=template&id=d4544bfa&"
import script from "./editVirtualColumnFilter.vue?vue&type=script&lang=js&"
export * from "./editVirtualColumnFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports